define('app/factories/message_factory',['app/setup', 'app/views/message_view', 'app/views/confirm_view'],
  function(takhfifan, message_view, confirmView) {
    new takhfifan.MessageView({
      document: $(document)
    });
    var $confirm = $('.confirm');
    if ($confirm) {
      new takhfifan.confirmView({el:$confirm});
    }
});

